import React, { useState, useEffect } from "react";

export default function Hero({ contactoRef }) {
  const fullText1 = "TRANSFORMANDO ORGANIZACIONES";
  const fullText2 = "impulsando futuro";

  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");

  const speed1 = 80;
  const speed2 = 100;
  const delayBetween = 300;

  useEffect(() => {
    let mounted = true;
    const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

    const runTypewriter = async () => {
      for (let i = 1; i <= fullText1.length; i++) {
        if (!mounted) return;
        setText1(fullText1.slice(0, i));
        await sleep(speed1);
      }

      await sleep(delayBetween);

      for (let j = 1; j <= fullText2.length; j++) {
        if (!mounted) return;
        setText2(fullText2.slice(0, j));
        await sleep(speed2);
      }
    };

    runTypewriter();
    return () => {
      mounted = false;
    };
  }, []);

  const finished1 = text1 === fullText1;
  const finished2 = text2 === fullText2;

  return (
    <section
      className="relative h-screen w-full flex items-center justify-center text-center overflow-hidden pt-24"
      style={{
        backgroundImage: "url('/assets/Fondo/portada-horizontal.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundOrigin: "content-box",
      }}
    >
      {/* Oscurecimiento */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* CONTENEDOR CENTRAL */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-[1400px] mx-auto px-4 sm:px-6 transform scale-90 sm:scale-100 -translate-y-10 sm:-translate-y-16">
        {/* LOGO — más grande SOLO en mobile */}
        <img
          src="/assets/logos/logo-10.png"
          alt="Core Solutions"
          className="w-[390px] sm:w-[285px] md:w-[445px] lg:w-[610px] max-w-none sm:max-w-full"
        />

        {/* TEXTO */}
        <div className="relative z-10 text-center w-full px-2 sm:px-0 mt-8 sm:mt-10">
          <h2 className="relative inline-block text-white leading-tight text-center">
            {/* Línea 1 — apenas más grande en mobile */}
            <span
              className="inline-block text-lg sm:text-2xl md:text-3xl uppercase tracking-tight"
              style={{
                fontFamily: "Cocogoose Pro",
                fontWeight: 50,
                letterSpacing: "0.05em",
                whiteSpace: "pre",
              }}
            >
              {text1}
              {!finished1 && <span className="ml-1 animate-pulse">|</span>}
            </span>

            {/* Línea 2 — doble de grande en mobile */}
            <span
              className="absolute left-1/2 -translate-x-1/2 text-2xl sm:text-3xl md:text-4xl italic lowercase"
              style={{
                top: "100%",
                marginTop: "6px",
                fontFamily: "Cocogoose",
                fontWeight: 200,
                whiteSpace: "pre",
              }}
            >
              {text2}
              {text2.length > 0 && !finished2 && (
                <span className="ml-1 animate-pulse">|</span>
              )}
            </span>
          </h2>
        </div>
      </div>

      {/* BOTÓN */}
      <div className="absolute bottom-24 sm:bottom-10 z-10">
        <button
          onClick={() =>
            contactoRef.current?.scrollIntoView({ behavior: "smooth" })
          }
          className="px-12 py-5 text-white font-semibold rounded-2xl shadow-lg transition duration-300 ease-in-out transform hover:scale-110 hover:bg-[#1a1070]"
          style={{ backgroundColor: "#120B3E" }}
        >
          Contactanos
        </button>
      </div>
    </section>
  );
}